/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagGroup } from '../../models/tag-group';

export interface DuplicateTagGroupsToInventory$Params {
  sourceInventoryId?: string;
  targetInventoryId?: string;
}

export function duplicateTagGroupsToInventory(http: HttpClient, rootUrl: string, params?: DuplicateTagGroupsToInventory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagGroup>>> {
  const rb = new RequestBuilder(rootUrl, duplicateTagGroupsToInventory.PATH, 'post');
  if (params) {
    rb.query('sourceInventoryId', params.sourceInventoryId, {});
    rb.query('targetInventoryId', params.targetInventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TagGroup>>;
    })
  );
}

duplicateTagGroupsToInventory.PATH = '/admin/tag-groups/duplicate';
